import axios, { AxiosResponse } from "axios";

import { LocalStorageService } from "../services/LocalStorageService";

export const printConsole = true;
// export const printConsole = false;
// export const baseAppURL = "/simplepay/v2/"; // for LOCAL
export const baseAppURL = "/"; // for LIVE

// export const baseURL = "http://192.168.1.4:8603/"; // for LOCAL
// export const baseURL = "http://127.0.0.1:8100/";
// export const baseURL = "http://127.0.0.1:8300/";

// export const baseURL = "http://192.168.1.4:8502";
// export const baseURL = "http://192.168.1.4:8802";
// export const baseURL = "http://192.168.1.4:8402";
// export const baseURL = "http://localhost:8200";

export const baseURL = "https://v3api.simplepay.ca/"; //for LIVE

// IN Package.json
// "homepage": "https://v3.simplepay.ca/",      //this will paste on package.json file                             //for LIVE
// "homepage": "http://192.168.1.4:8700/simplepay/v2/",      //this will paste on package.json file                //for LOCAL

const http = axios.create({
  baseURL: baseURL,
  withCredentials: true,
  headers: {
    "Content-type": "application/json",
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Methods": "POST, GET, OPTIONS, PUT, DELETE",
    "Access-Control-Allow-Headers":
      "Context-Type, X-Auth-Token, Origin, Authorization",
  },
});

const requestHandler = (request: any) => {
  request.headers["Authorization"] =
    `Bearer ${LocalStorageService.getUserToken()}`;
  return request;
};

const responseSuccessHandler = (response: AxiosResponse<never>) => {
  return response;
};

const responseErrorHandler = (error: { response: { status: number } }) => {
  if (
    error.response &&
    error.response.status === 401 &&
    window.location.href.includes("/login")
  ) {
    return Promise.resolve(error.response);
  } else if (
    error.response &&
    (error.response.status === 401 || error.response.status === 403)
  ) {
    // AuthService.signOut();
    // window.location.href = "/";
    //window.location.reload();

    localStorage.clear();
    window.sessionStorage.setItem("maskEnabled", "true");
    sessionStorage.removeItem("unmaskTime");
    // window.location.href = "/taxslips_v6.com/"; //for local server build
    window.location.href = "/"; //for app.live build
  } else if (error.response && error.response.status === 400) {
    return error.response;
  }

  return Promise.reject(error);
};

http.interceptors.request.use(
  (request: any) => requestHandler(request),
  (error: any) => console.error("error =>", error),
);

http.interceptors.response.use(
  (response: any) => responseSuccessHandler(response),
  (error: any) => responseErrorHandler(error),
);

export default http;

// WHY OPTIONS CALLS BEFORE ACTUAL CALL LIKE BEFORE GET,POST ETC

// When you make a cross-origin HTTP request, the browser sends an OPTIONS request first to the target
// server to ask for permission before sending the actual request.

// This OPTIONS request checks:

// => If the HTTP method (e.g., PUT, DELETE) is allowed.

// => If the custom headers (like Authorization) are permitted.

// => If the origin (http://localhost:3000, for example) is allowed.

// If the server responds positively, the browser proceeds to make the actual request (GET, POST, etc.).

// build issue
// "build": "npm run clean && vite build",
// "build": "node --max-old-space-size=8192 node_modules/vite/bin/vite.js build",
// pk354

// when ever collectionVoucherFieldsTable change then table re renders
// key={JSON.stringify(collectionVoucherFieldsTable)}
